import { useFeatureFlag, FLAGS } from '@hub-la/fe-core-feature-flag';
import { MultigatewayHandler } from '../../usecases/multigateway-handler.js';

/**
 * Custom hook for handling multigateway logic.
 *
 * @param offerId - The ID of the offer.
 * @returns The gateway configured for this offer, if there's nothing configured, returns the defaultGateway.
 */
const useMultigatewayHandler = offerId => {
  var _a, _b;
  const {
    isFlagEnabled,
    getFlagValue,
    getFlagParams
  } = useFeatureFlag();
  const hasCustomGateway = isFlagEnabled(FLAGS.CHECKOUT.CHECKOUT_MULTIGATEWAY_FALLBACK_SETTINGS, {
    id: offerId
  });
  const gatewaysForOffer = getFlagValue(FLAGS.CHECKOUT.CHECKOUT_MULTIGATEWAY_FALLBACK_SETTINGS, {
    id: offerId
  });
  const gatewaysFromParams = getFlagParams(FLAGS.CHECKOUT.CHECKOUT_MULTIGATEWAY_FALLBACK_SETTINGS);
  return new MultigatewayHandler(hasCustomGateway, gatewaysForOffer, {
    defaultGateways: (_a = gatewaysFromParams['defaultGateways']) !== null && _a !== void 0 ? _a : [],
    allGateways: (_b = gatewaysFromParams['allGateways']) !== null && _b !== void 0 ? _b : []
  }).execute();
};

export { useMultigatewayHandler };
